export function getFont(fontName: string): string {
  return `local(''),
  url('${'/fonts/' + fontName + '.woff2'}') format('woff2'),
  url('${'/fonts/' + fontName + '.woff'}') format('woff')`;
}
